import { logAPICall, logError } from './telemetry';

/**
 * Wrap fetch with automatic logging
 */
export async function trackedFetch(url, options = {}) {
    const startTime = performance.now();
    const method = options.method || 'GET';
    
    try {
        const response = await fetch(url, options);
        const duration = performance.now() - startTime;
        
        await logAPICall(url, method, response.status, duration, {
            success: response.ok,
            statusText: response.statusText
        });
        
        return response;
    } catch (error) {
        const duration = performance.now() - startTime;
        
        await logAPICall(url, method, 0, duration, {
            success: false,
            error: error.message
        });
        
        await logError(error, {
            context: 'api_call',
            url,
            method
        });
        
        throw error;
    }
}

/**
 * Monitor network conditions
 */
export function getNetworkConditions() {
    if (!navigator.connection) return { unknown: true };
    
    return {
        effectiveType: navigator.connection.effectiveType,
        downlink: navigator.connection.downlink,
        rtt: navigator.connection.rtt,
        saveData: navigator.connection.saveData
    };
}
